<!-- Layout Container -->
<div class="layout">
  <div class="layout__container">
    <!-- Overlay for mobile -->
    @if (isMobile && isExpanded) {
      <div class="layout__overlay" (click)="closeSidebar()"></div>
    }
    
    <!-- Sidebar -->
    <div class="layout__sidebar" 
         [class.layout__sidebar--collapsed]="!isExpanded"
         [class.layout__sidebar--mobile-hidden]="isMobile && !isExpanded">
      <app-sidebar 
        [isExpanded]="isExpanded"
        [isDarkTheme]="isDarkTheme"
        (toggleSidebarEvent)="toggleSidebar()">
      </app-sidebar>
    </div>

    <!-- Main Content -->
    <div class="layout__content" [class.layout__content--expanded]="!isExpanded">
        <div class="main-container">
          <div class="content-card">
            <div class="content-header">
              <app-header 
                [title]="pageTitle"
                [isDarkTheme]="isDarkTheme"
                (themeToggle)="toggleTheme()"
                (menuToggle)="toggleSidebar()">
              </app-header>
            </div>
            <app-breadcrumb 
              [items]="breadcrumbItems"
              [home]="{ link: '/', label: 'layout.sidebar.home' | translate }"
              >
            </app-breadcrumb>
            <div class="content-body">
              <div class="inner-card">
              <router-outlet></router-outlet>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> 